import { cva } from 'class-variance-authority';

export const defaultCellVariants = cva([], {
  variants: {
    intent: {
      small: 'text-body-small',
      base: 'text-body-regular',
    },
  },
  defaultVariants: {
    intent: 'small',
  },
});
